// extracted by mini-css-extract-plugin
export default {"container":"sWAYxH mz-sr-category","icon":"PNoSCO mz-sr-category__icon","categoryName":"RSuivx mz-sr-category__name"};